export default __webpack_public_path__ + "static/media/white_kindred_logo.9d506daf.png";